import React from 'react';
import { FileText, Phone, Camera, Users, Smartphone, Heart, Brain } from 'lucide-react';
export function IncludedSection() {
  return <section className="py-24 px-4 bg-[#0a0a0a] border-t border-[#333]" data-id="element-51">
      <div className="max-w-5xl mx-auto" data-id="element-52">
        <h2 className="text-3xl md:text-5xl font-bold text-[#c8b89a] font-['Special_Elite'] text-center mb-16" data-id="element-53">
          ¿QUÉ INCLUYE CADA EXPEDIENTE?
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mb-20" data-id="element-54">
          <div className="space-y-8" data-id="element-55">
            <div className="flex gap-4" data-id="element-56">
              <div className="bg-[#222] p-3 rounded-sm h-fit" data-id="element-57">
                <FileText className="w-6 h-6 text-[#c8b89a]" data-id="element-58" />
              </div>
              <div data-id="element-59">
                <h3 className="text-xl font-bold text-white mb-1 font-['Special_Elite']" data-id="element-60">
                  Reportes Policiales y Memorándums
                </h3>
                <p className="text-gray-400 text-sm" data-id="element-61">
                  Para que entiendas el contexto desde el minuto uno.
                </p>
              </div>
            </div>

            <div className="flex gap-4" data-id="element-62">
              <div className="bg-[#222] p-3 rounded-sm h-fit" data-id="element-63">
                <Phone className="w-6 h-6 text-[#c8b89a]" data-id="element-64" />
              </div>
              <div data-id="element-65">
                <h3 className="text-xl font-bold text-white mb-1 font-['Special_Elite']" data-id="element-66">
                  Transcripciones de Llamadas y Audios
                </h3>
                <p className="text-gray-400 text-sm" data-id="element-67">
                  Siente la tensión del momento del hallazgo.
                </p>
              </div>
            </div>

            <div className="flex gap-4" data-id="element-68">
              <div className="bg-[#222] p-3 rounded-sm h-fit" data-id="element-69">
                <Camera className="w-6 h-6 text-[#c8b89a]" data-id="element-70" />
              </div>
              <div data-id="element-71">
                <h3 className="text-xl font-bold text-white mb-1 font-['Special_Elite']" data-id="element-72">
                  Fotos de Evidencia e Informes Forenses
                </h3>
                <p className="text-gray-400 text-sm" data-id="element-73">
                  Nada de dibujos infantiles; esto se siente real.
                </p>
              </div>
            </div>
          </div>

          <div className="space-y-8" data-id="element-74">
            <div className="flex gap-4" data-id="element-75">
              <div className="bg-[#222] p-3 rounded-sm h-fit" data-id="element-76">
                <Users className="w-6 h-6 text-[#c8b89a]" data-id="element-77" />
              </div>
              <div data-id="element-78">
                <h3 className="text-xl font-bold text-white mb-1 font-['Special_Elite']" data-id="element-79">
                  Interrogatorios de Sospechosos
                </h3>
                <p className="text-gray-400 text-sm" data-id="element-80">
                  Lee entre líneas. Busca las contradicciones.
                </p>
              </div>
            </div>

            <div className="flex gap-4" data-id="element-81">
              <div className="bg-[#222] p-3 rounded-sm h-fit" data-id="element-82">
                <Smartphone className="w-6 h-6 text-[#c8b89a]" data-id="element-83" />
              </div>
              <div data-id="element-84">
                <h3 className="text-xl font-bold text-white mb-1 font-['Special_Elite']" data-id="element-85">
                  Evidencia Digital
                </h3>
                <p className="text-gray-400 text-sm" data-id="element-86">
                  Capturas de pantalla, correos y registros de seguridad.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Use Cases */}
        <div className="bg-[#111] border border-[#333] p-8 md:p-12 rounded-sm" data-id="element-87">
          <h3 className="text-2xl text-center text-white font-['Special_Elite'] mb-10" data-id="element-88">
            EL PLAN PERFECTO PARA...
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-89">
            <div className="text-center" data-id="element-90">
              <div className="bg-[#cc2200]/10 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-91">
                <Heart className="w-8 h-8 text-[#cc2200]" data-id="element-92" />
              </div>
              <h4 className="font-bold text-[#c8b89a] mb-2" data-id="element-93">
                Citas Inolvidables
              </h4>
              <p className="text-sm text-gray-400" data-id="element-94">
                Olvida el silencio incómodo en el cine. Trabajad codo con codo.
              </p>
            </div>
            <div className="text-center" data-id="element-95">
              <div className="bg-[#cc2200]/10 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-96">
                <Users className="w-8 h-8 text-[#cc2200]" data-id="element-97" />
              </div>
              <h4 className="font-bold text-[#c8b89a] mb-2" data-id="element-98">
                Reuniones con Amigos
              </h4>
              <p className="text-sm text-gray-400" data-id="element-99">
                Desafía a tu grupo. ¿Quién tiene mejor ojo para los detalles?
              </p>
            </div>
            <div className="text-center" data-id="element-100">
              <div className="bg-[#cc2200]/10 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-101">
                <Brain className="w-8 h-8 text-[#cc2200]" data-id="element-102" />
              </div>
              <h4 className="font-bold text-[#c8b89a] mb-2" data-id="element-103">
                Momentos a Solas
              </h4>
              <p className="text-sm text-gray-400" data-id="element-104">
                Pon a prueba tu propio coeficiente intelectual. Entrenamiento
                mental definitivo.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}